import { get } from './get';

export const alertBackgroundColor = key => get(`alert.backgroundColor.${key}`);
export const alertBorderColor = key => get(`alert.borderColor.${key}`);
